var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-bg",
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "icon-color",
    x: 12,
    y: 12,
    width: 7,
    height: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "icon-color",
    x: 21,
    y: 23,
    width: 7,
    height: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.25C11.5858 11.25 11.25 11.5858 11.25 12V17C11.25 17.4142 11.5858 17.75 12 17.75H18.5C18.9142 17.75 19.25 17.4142 19.25 17V12C19.25 11.5858 18.9142 11.25 18.5 11.25H12ZM12.75 16.25V12.75H17.75V16.25H12.75ZM12 19.25C11.5858 19.25 11.25 19.5858 11.25 20V28C11.25 28.4142 11.5858 28.75 12 28.75H18.5C18.9142 28.75 19.25 28.4142 19.25 28V20C19.25 19.5858 18.9142 19.25 18.5 19.25H12ZM12.75 27.25V20.75H17.75V27.25H12.75ZM28.75 28C28.75 28.4142 28.4142 28.75 28 28.75H21.5C21.0858 28.75 20.75 28.4142 20.75 28L20.75 23C20.75 22.5858 21.0858 22.25 21.5 22.25L28 22.25C28.4142 22.25 28.75 22.5858 28.75 23V28ZM27.25 27.25V23.75L22.25 23.75V27.25L27.25 27.25ZM28 20.75C28.4142 20.75 28.75 20.4142 28.75 20V12C28.75 11.5858 28.4142 11.25 28 11.25H21.5C21.0858 11.25 20.75 11.5858 20.75 12L20.75 20C20.75 20.4142 21.0858 20.75 21.5 20.75L28 20.75ZM27.25 12.75V19.25L22.25 19.25L22.25 12.75L27.25 12.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.8f5d7ff2602dace47134cda7c9788ace.svg";
export { ForwardRef as ReactComponent };